import { render, staticRenderFns } from "./TextImage.vue?vue&type=template&id=40694218&scoped=true"
import script from "./TextImage.vue?vue&type=script&lang=ts"
export * from "./TextImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40694218",
  null
  
)

export default component.exports